import { render, staticRenderFns } from "./AsignacionArma.vue?vue&type=template&id=011a6134&scoped=true"
import script from "./AsignacionArma.vue?vue&type=script&lang=js"
export * from "./AsignacionArma.vue?vue&type=script&lang=js"
import style0 from "./AsignacionArma.vue?vue&type=style&index=0&id=011a6134&prod&lang=css"
import style1 from "./AsignacionArma.vue?vue&type=style&index=1&id=011a6134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011a6134",
  null
  
)

export default component.exports